/**
 * What an onboarding document slot accepts.
 *
 * Mirrors yaas-api `OnboardingDocumentService` — `ALLOWED_MIME_TYPES`
 * (application/pdf, image/jpeg, image/png) and `MAX_UPLOAD_SIZE_BYTES`
 * (25 MB). Both are enforced server-side regardless; declaring them on the
 * control means a bad file is refused before it costs a round trip, and it
 * is what `UploadFiles` derives its "Supported File Types" line from.
 *
 * Keep in sync with the backend constants. A slot that accepts more than
 * the server does surfaces as an upload that fails after the progress bar
 * has already run.
 */
export const DOCUMENT_ACCEPT = ".pdf,.jpg,.jpeg,.png";

/** 25 MB, matching `MAX_UPLOAD_SIZE_BYTES`. */
export const DOCUMENT_MAX_SIZE = 25 * 1024 * 1024;
